import axios, { AxiosResponse } from "axios";
import {  Product } from "../@types/Product";
import { Category } from "../@types/Category";

const endpoint_login = 'product'; 
  
  
const API_BASE_URL= process.env.REACT_APP_API_URL as string + endpoint_login

  export const ProductService = {
    /**
     * Agregar un nuevo producto
     * @param product - Producto a agregar
     */
    addProduct: async (product: Product): Promise<AxiosResponse> => {
      // Validar datos del producto antes de enviarlo
      if (!product.sku || !product.name || product.regular_price <= 0 || product.stock_quantity < 0) {
        throw new Error(
          'Datos inválidos: asegúrate de que el SKU, nombre, precio y cantidad en stock sean correctos.'
        );
      }
  
      try {
        const response = await axios.post(API_BASE_URL, product);
        return response;
      } catch (error: any) {
        handleError(error);
      }
    },
  
    /**
     * Subir una imagen de producto
     * @param formData - Datos del formulario (imagen, SKU, ID)
     */
    uploadProductImage: async (formData: FormData): Promise<AxiosResponse> => {
      // Validar datos antes de enviar
      if (!formData.has('image') || !formData.has('sku') || !formData.has('id')) {
        throw new Error('Datos inválidos: la imagen, el SKU y el ID son obligatorios.');
      }
  
      try {

        const response = await axios.post(`${API_BASE_URL}/image`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        return response;
      } catch (error: any) {
        handleError(error);
      }
    },
  
    /**
     * Obtener todos los productos
     */
    getProducts: async (): Promise<Product[]> => {
      try {
        const response = await axios.get(API_BASE_URL  + "?status=publish");
        return response.data;
      } catch (error: any) {
        handleError(error);
      }
    },

        /**
     * Actualizar un producto existente
     * @param sku - Sku del producto

     */

  /**
   * Obtener la imagen del producto en formato Base64
   * @param sku - SKU del producto
   */
  getProductImage: async (sku: string): Promise<string> => {
    try {
      const response = await axios.get(`${API_BASE_URL}/image`, {
        params: { sku },
      });

      // La imagen se devuelve como una cadena en Base64, directamente lista para usarse como src de una imagen
      return response.data.image; // Asegúrate de que el backend devuelva la imagen como un campo 'image' en Base64
    } catch (error: any) {

      throw new Error('No se pudo obtener la imagen del producto.');
    }
  },
  /**
 * Obtener la imagen del producto en formato Base64
 * @param sku - SKU del producto
 */
 getCategories: async (): Promise<Category[]> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/categories`);
    return response.data;
  } catch (error: any) {
    handleError(error);
  }
},
  
    /**
     * Actualizar un producto existente
     * @param productId - ID del producto a actualizar
     * @param updatedProduct - Datos actualizados
     */
    updateProduct: async (productId: number, updatedProduct: Partial<Product>): Promise<AxiosResponse> => {
      if (!productId || Object.keys(updatedProduct).length === 0) {
        throw new Error('Datos inválidos: se requiere un ID válido y datos para actualizar.');
      }
  
      try {
        const response = await axios.put(`${API_BASE_URL}/${productId}`, updatedProduct);
        return response;
      } catch (error: any) {
        handleError(error);
      }
    },
  
    /**
     * Eliminar un producto
     * @param productId - ID del producto a eliminar
     */
    deleteProduct: async (productId: number): Promise<AxiosResponse> => {
      if (!productId) {
        throw new Error('Datos inválidos: se requiere un ID válido para eliminar un producto.');
      }
  
      try {
        const response = await axios.delete(`${API_BASE_URL}/${productId}`);
        return response;
      } catch (error: any) {
        handleError(error);
      }
    },
  };
  
  /**
   * Manejo centralizado de errores para las solicitudes
   * @param error - Error lanzado por axios
   */
  function handleError(error: any): never {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // El servidor respondió con un código de error
        throw new Error(
          `Error en la respuesta del servidor (${error.response.status}): ${error.response.data?.message || 'Error desconocido.'}`
        );
      } else if (error.request) {
        // La solicitud fue enviada, pero no se recibió respuesta
        throw new Error('No se recibió respuesta del servidor. Verifica tu conexión.');
      }
    }
    // Error desconocido
    throw new Error(`Error inesperado: ${error.message || 'Error desconocido'}`);
  }